import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    constructor(
        private snackBar: MatSnackBar,
        private translate: TranslateService
    ) { }

    public openSnackBar(message: string) {
        this.snackBar.open(message, '', {
            duration: 5000
        });
    }

    public displayError(message: string) {
        this.snackBar.open(message , '', {
            duration: 5000
        });
    }

    public displayErrorExtra(message: string) {
        const fullMessage = message + " " + this.translate.instant('GLOBAL_TRY_AGAIN_LATER');
        this.snackBar.open(fullMessage , '', {
            duration: 5000
        });
    }
}
